<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招标中心 </el-breadcrumb-item>
        <el-breadcrumb-item>查看投标结果</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrap">
      <div class="change_inform">
        <div class="title">项目信息</div>
        <el-form :inline="true" :model="PurchaseScheme" class="form_table">
          <el-form-item label="采购编号">{{ PurchaseScheme.SchemeCode }}</el-form-item>
          <el-form-item label="项目名称">{{ PurchaseScheme.ProjectName }}</el-form-item>
          <el-form-item :label="biddedSupplierTitle">{{ PurchaseScheme.BiddedSupplier }}</el-form-item>
          <el-form-item label="附件">
            <div>
              <span v-if="PurchaseScheme.IsWin">{{ winbidTitle }}</span>
              <span v-if="!PurchaseScheme.IsWin">{{ bidResulTitle }}</span>
              <el-link class="link" @click="fnDownload(PurchaseScheme.BiddingFileId, PurchaseScheme.IsWin ? winbidTitle : bidResulTitle)">下载</el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">招标内容</div>
        <el-table class="table_wrap1" :data="TechnicalTransforList" style="width: 98%; margin: 0 auto" border>
          <el-table-column prop="Index" label="序号"></el-table-column>
          <el-table-column prop="InstrumentName" label="设备名称"></el-table-column>
          <!-- <el-table-column prop="Specification" label="设备型号"></el-table-column> -->
          <el-table-column prop="Count" label="数量（套）"></el-table-column>
          <el-table-column prop="Remark" label="备注"></el-table-column>
        </el-table>
      </div>
      <div class="btn_wrap">
        <span class="btn" @click.stop="CancelEvents">确认</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      PurchaseScheme: {},
      TechnicalTransforList: [],
      biddedSupplierTitle: '',
      winbidTitle: '',
      bidResulTitle: ''
    }
  },
  mounted() {
    this.fnInit()
  },
  methods: {
    fnDownload(fileId, fileName) {
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName=' + fileName

      this.downloadfile(this.baseURL + url)
    },
    CancelEvents() {
      window.close()
    },
    fnInit() {
      let config = {
        params: {
          AutoId: this.$route.query.id
        }
      }
      this.getRequest('/Purchase/GetBidResultDetail', config)
        .then((res) => {
          var data = res.data
          if (res.data.errcode == 0) {
            this.TechnicalTransforList = res.data.TechnicalTransforList
            this.PurchaseScheme = res.data.PurchaseScheme
            if (this.PurchaseScheme.PurchaseMethod == 2) {
              this.biddedSupplierTitle = '中标单位'
              this.winbidTitle = '中标通知书'
              this.bidResulTitle = '中标结果通知书'
            } else if (this.PurchaseScheme.PurchaseMethod == 3) {
              this.biddedSupplierTitle = '中选单位'
              this.winbidTitle = '中选通知书'
              this.bidResulTitle = '比选结果通知书'
            } else if (this.PurchaseScheme.PurchaseMethod == 4 || this.PurchaseScheme.PurchaseMethod == 5) {
              this.biddedSupplierTitle = '成交单位'
              this.winbidTitle = '成交通知书'
              this.bidResulTitle = '结果通知书'
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.mb_nav_pos {
  padding: 5px 0 0;
}
.link {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 8px;
  padding: 0px 15px;
  margin: 5px 23px;
  height: 24px;
  cursor: pointer;
}
.btn_wrap {
  padding-top: 25px;
  text-align: center;
  .btn {
    margin: auto;
    color: white;
    border: 1px solid #6a96bc;
    border-radius: 20px;
    padding: 10px 50px;
    cursor: pointer;
    background: #0774d7;
    width: 50px;
  }
}
.change_inform {
  padding-top: 15px;
  .title {
    height: 34px !important;
    line-height: 40px !important;
    border-bottom: 1px solid #95c7f0 !important;
    margin-bottom: 13px;
    // padding-top: 15px !important;
  }
  ::v-deep .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #95c7f0;
  }
  ::v-deep .table_wrap1 {
    table {
      margin: 0;
      td,
      tr,
      th {
        border-color: #95c7f0;
      }
      th {
        border-top: 1px solid #95c7f0;
        border-right: 1px solid #95c7f0;
        border-color: #95c7f0;
        background-color: #d8eafa;
        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }
      td {
        border-bottom: none;
        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }
    }
    .el-table__body-wrapper {
      border-bottom: 1px solid #95c7f0;
    }
  }
}
.EnterpriseInform {
  .content_wrap {
    padding-bottom: 50px;
    margin-bottom: 20px;
  }
}
</style>
